import { Box, Paper } from "@mui/material";
var CustomTooltip = function (_ref) {
    var barIndex = _ref.barIndex, barHeight = _ref.barHeight, tooltipValue = _ref.tooltipValue;
    return /*#__PURE__*/ React.createElement(Box, {
        component: Paper,
        elevation: 4,
        sx: {
            position: "absolute",
            top: 200 - barHeight - 104,
            left: "".concat(barIndex * (35 + 10) + 35 / 2 + 6, "px"),
            transform: "translateX(-50%)",
            backgroundColor: "black",
            color: "white",
            p: '12px',
            borderRadius: "8px",
            textAlign: "center",
            minWidth: 100,
            fontWeight: "strong",
            fontSize: 'sm'
        }
    }, "Avl slots ".concat(tooltipValue, "/50"), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: "absolute",
            bottom: -4,
            left: "45%",
            width: "12px",
            height: "12px",
            backgroundColor: "black",
            borderRadius: "1px",
            transform: "rotate(45deg)"
        }
    }));
};
export default CustomTooltip;
